export default __webpack_public_path__ + "static/media/as-you-wish.38726a85.gif";